<template>
  <v-expansion-panels
    data-qa="club_faq_list"
    multiple
  >
    <v-expansion-panel
      v-for="(faq, index) in faqList"
      :key="index"
    >
      <v-expansion-panel-header
        expand-icon="ui-icon-arrow-down"
        class="text-left justify-space-between"
      >
        <span class="text-body-1">{{ faq.title }}</span>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="text-body-1">
        <span class="text-pre-line">{{ faq.description }}</span>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts" setup>
const faqList = [
  {
    title: 'Как стать участником клуба',
    description: 'Просто воспользуйтесь клубной ценой и станете участником на 6 месяцев.\n\n'
      + 'Потом доступ к клубу будет стоить 99 ₽ на 6 месяцев.',
  },
  {
    title: 'На что действует скидка',
    description: 'Скидка по опциону даётся только на консультацию врача. Если врач оказывает допуслуги: инъекция, мазок, биопсия и прочее  — они оплачиваются отдельно.',
  },
  {
    title: 'К каким врачам можно записаться по клубной цене',
    description: 'Только к тем, у кого указана клубная цена за приём. Если её нет, значит клиника врача не вступила в клуб.',
  },
  {
    title: 'Входит ли опцион в стоимость приёма',
    description: 'Нет. Опцион — это право на скидку, а не предоплата консультации. Вы покупаете опцион, а в клинике оплачиваете приём уже по сниженной цене.',
  },
  {
    title: 'Что будет, если не оплатить опцион',
    description: 'Если не оплатить опцион в течение 20 минут после записи к врачу, запись отменится.',
  },
  {
    title: 'Если я не могу прийти на приём',
    description: 'Если вы не придёте в выбранное время, опцион и скидка сгорят. Обратитесь в клинику, возможно, они согласятся перенести приём.',
  },
]
</script>
